import Widget from '@/plugins/dashboard/widgets/Example/Widget'
import Configure from '@/plugins/dashboard/widgets/Example/Configure'

const RDATA_MINIMUM = 100
const RDATA_MAXIMUM = 1000

export default {
  name: 'Example',
  widget: Widget,
  configure: Configure,
  getData: async function (configuration) {
    return [
      {
        name: 'example',
        data: [
          {
            x: 'Muskrat',
            y: (Math.random() * (RDATA_MAXIMUM - RDATA_MINIMUM + 1)) << 0
          },
          {
            x: 'Antelope',
            y: (Math.random() * (RDATA_MAXIMUM - RDATA_MINIMUM + 1)) << 0
          },
          {
            x: 'Okapi',
            y: (Math.random() * (RDATA_MAXIMUM - RDATA_MINIMUM + 1)) << 0
          },
          {
            x: 'Llama',
            y: (Math.random() * (RDATA_MAXIMUM - RDATA_MINIMUM + 1)) << 0
          },
          {
            x: 'Oryx',
            y: (Math.random() * (RDATA_MAXIMUM - RDATA_MINIMUM + 1)) << 0
          },
          {
            x: 'Capybara',
            y: (Math.random() * (RDATA_MAXIMUM - RDATA_MINIMUM + 1)) << 0
          },
          {
            x: 'Civet',
            y: (Math.random() * (RDATA_MAXIMUM - RDATA_MINIMUM + 1)) << 0
          }
        ]
      }
    ]
  }
}
